<script>
import { mapGetters } from 'vuex';
import AccordionTransition from '../FormGuideEventCard/common/AccordionTransition.vue';
import BettingPromotionsTermsModal from './BettingPromotionsTermsModal.vue';
import BettingPromotionsList from './BettingPromotionsList.vue';
import ClickOutside from 'vue-click-outside';
import ViewportWidth from '../../mixins/ViewportWidth';
export default {
  name: 'BettingPromotions',
  directives: {
    ClickOutside,
  },
  components: {
    AccordionTransition,
    BettingPromotionsTermsModal,
    BettingPromotionsList,
  },
  mixins: [ViewportWidth],
  props: {
    eventId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      detailsActive: false,
    };
  },
  computed: {
    ...mapGetters({
      bettingPromotions: 'BettingPromotions/getBettingPromotionsList',
      tcsModalActive: 'BettingPromotions/getTCsModalStatus',
      tcsText: 'BettingPromotions/getTCsModalText',
    }),
    getNoOfPromos() {
      return this.bettingPromotions.length;
    },
    isMobile() {
      return this.viewportWidth < 768;
    },
  },
  mounted() {
    const { fetchPromotions, eventId } = this;
    fetchPromotions(eventId);
  },
  methods: {
    fetchPromotions(eventId) {
      this.$store.dispatch('BettingPromotions/fetchPromotionsByEventId', eventId);
    },
    toggleTCsModal(isActive, text) {
      this.$store.dispatch('BettingPromotions/toggleModalStatus', { isActive, text });
    },
    toggleDetailsActive() {
      this.detailsActive = !this.detailsActive;
    },
    closeModal() {
      this.$store.dispatch('BettingPromotions/toggleModalStatus', { isActive: false, text: '' });
    },
  },
};
</script>

<template>
  <div v-if="getNoOfPromos > 0" class="betting-promotions">
    <div class="betting-promotions__section">
      <div class="betting-promotions__section-header" @click.prevent="toggleDetailsActive">
        <div class="betting-promotions__section-header-left">Bookie Offers ({{ getNoOfPromos }})</div>
        <div :class="{ 'up': detailsActive }" class="betting-promotions__section-header-right">
          <svg width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path
              d="M12.682 4.018c.3 0 .5.1.7.3.4.4.4 1 0 1.4l-4.5 4.5 4.5 4.5c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-6-6 6-6c.2 0 .4-.1.7-.1"
              fill="#fff"
            />
          </svg>
        </div>
      </div>
      <AccordionTransition>
        <div v-if="detailsActive" class="betting-promotions__section-details">
          <template v-if="!isMobile">
            <div class="betting-promotion__desktop">
              <div
                v-for="(promotion, index) in bettingPromotions"
                :key="`promotion-${index}`"
                class="betting-promotion"
              >
                <div :class="`betting-promotion__hero ${promotion.bookmaker}-bg-color`">
                  <img
                    :src="`https://puntcdn.com/Logos/${promotion.bookmaker}/lightondark.svg`"
                    class="betting-promotion__hero-img"
                  >
                </div>
                <div class="betting-promotion__main">
                  <h2 class="betting-promotion__main-title">{{ promotion.heading1 }}</h2>
                  <p class="betting-promotion__main-text">{{ promotion.heading2 }}</p>
                </div>
                <div class="betting-promotion__main-right">
                  <div
                    :data-betting-promotion-id="promotion.id"
                    class="betting-promotion__main-terms"
                    @click.prevent="toggleTCsModal(true, promotion.terms)"
                  >T&C's Apply</div>
                  <a
                    :href="`${promotion.primaryBookmakerUrl}`"
                    :class="`betting-promotion__cta ${promotion.bookmaker}-bg-color`"
                    target="_blank"
                  >{{ promotion.primaryBookmakerUrlLabel }}</a>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <BettingPromotionsList :promos="bettingPromotions" />
          </template>
        </div>
      </AccordionTransition>
    </div>
    <template v-if="tcsModalActive">
      <div class="betting-promotions__tcs-modal-mask">
        <div class="betting-promotions__tcs-modal-container">
          <BettingPromotionsTermsModal v-click-outside="closeModal" :terms-text="tcsText" />
        </div>
      </div>
    </template>
  </div>
</template>
